import React, { useState } from "react"
import styled from "styled-components"

import QuestionIcon from "../questionIcon"

const StyledRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: ${(props) => props.theme.font.sans};
    font-size: ${(props) => (props.isBold ? "1.2rem" : "1.0rem")};
    line-height: 1.8rem;
    font-weight: ${(props) => (props.isBold ? "bold" : "normal")};
    ${(props) => props.theme.responsive.mobile} {
        font-size: ${(props) => (props.isBold ? "1rem" : "0.8rem")};
    }
`

const StyledTitle = styled.div`
    flex: 1;
`

const StyledDescription = styled.div`
    text-align: right;
    margin-left: ${(props) => (props.hasTooltip ? "0.4rem" : "0")};
`

const Row = ({ isBold, title, description, tooltip }) => {
    const [isTooltipShown, setIsTooltipShown] = useState(false)
    return (
        <StyledRow isBold={isBold}>
            <StyledTitle>{title}</StyledTitle>
            {tooltip && (
                <QuestionIcon
                    handleClick={() => {
                        setIsTooltipShown(!isTooltipShown)
                    }}
                >
                    {isTooltipShown && tooltip}
                </QuestionIcon>
            )}
            <StyledDescription hasTooltip={tooltip}>
                {description}
            </StyledDescription>
        </StyledRow>
    )
}

export default Row
